var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundCirclesKpi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 784.5 491.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        font-size: 140px;\n      }\n\n      .st1, .st2, .st3 {\n        font-family: WorkSans-Medium, 'Work Sans';\n        font-weight: 500;\n      }\n\n      .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9 {\n        fill: #fff;\n      }\n\n      .st10 {\n        fill: #1f2237;\n      }\n\n      .st10, .st11 {\n        display: none;\n      }\n\n      .st12, .st5 {\n        opacity: .1;\n      }\n\n      .st2 {\n        font-size: 50px;\n      }\n\n      .st13 {\n        clip-path: url(#clippath);\n      }\n\n      .st3 {\n        font-size: 30px;\n      }\n\n      .st4 {\n        opacity: 0;\n      }\n\n      .st4, .st5, .st6, .st7, .st8, .st9 {\n        isolation: isolate;\n      }\n\n      .st6 {\n        opacity: .3;\n      }\n\n      .st7 {\n        opacity: .2;\n      }\n\n      .st8 {\n        opacity: .5;\n      }\n\n      .st9 {\n        opacity: .4;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 784.5,
    height: 491.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    y: -63.2,
    width: 841.9,
    height: 595.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M589.7,234.2c0,113.5,67.2,180,182.8,180s48.8-3.3,69.4-9.6v-54.8c-19.1,9.4-42.3,14.3-69,14.3-83.7,0-132.3-48.1-132.3-130.3s48.6-130.3,132.3-130.3,49.9,4.9,69,14.3v-54.1c-20.6-6.3-43.8-9.5-69.4-9.5-115.6,0-182.8,66.5-182.8,180h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M772.5,153.6c-51.8,0-81.9,29.8-81.9,80.6s30.1,80.6,81.9,80.6,56-11.5,69.4-32.4v-96.4c-13.4-20.9-37.2-32.4-69.4-32.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M490.8,233.8c0,175.2,103.6,277.8,282.1,277.8s47.5-1.9,69-5.7v-50.4c-21.2,4.7-44.2,7.1-69,7.1h0c-146.9,0-232.3-84.4-232.3-228.7S625.9,5.1,772.9,5.1s47.8,2.4,69,7.1v-50.4c-21.6-3.8-44.6-5.7-69-5.7-178.4,0-282.1,102.6-282.1,277.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M472.3,532.1h129.9c-107.3-49.9-166.6-153.3-166.6-298.3S494-12.8,599.5-63.2h-128.6c-70,69-107.6,169.8-107.6,297s38.1,229.2,108.9,298.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.3,532.1c-36.7-84.8-55.8-184.5-55.8-297.6S153.7,21.6,190.4-63.2H41.5C19,5.8,5,81.7,0,164.1v140.6c5,82.5,19,158.4,41.5,227.4h148.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M265.5,532.1h122.1c-56.2-76.1-86.1-176.7-86.1-298.2S331.1,12.8,386.7-63.2h-121.9c-42.1,82.2-64.2,181.8-64.2,297s22.3,215.9,64.9,298.3Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(307.3 291.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(299.3 129)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Applied")), /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(252.2 393.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Candidates in total")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCirclesKpi);
export default __webpack_public_path__ + "static/media/background-circles-kpi.d82196e6fef8da4033522cee5ec81fe2.svg";
export { ForwardRef as ReactComponent };